// extracted by mini-css-extract-plugin
export default {"root":"ExpertCard_root__2loDL","status":"ExpertCard_status__iNTcB","expertInfo":"ExpertCard_expertInfo__XWhQb"};